import React, { useState, useRef, useEffect } from 'react';
import { FaMagic } from '@react-icons/all-files/fa/FaMagic';
import { generateDescription } from '../../../../services/aiservice';
import { Button } from 'antd';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FaTimes } from '@react-icons/all-files/fa/FaTimes';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { MoonLoader } from "react-spinners"
import "./index.scss";
import { postRequest } from '../../../../services/requestService';

const DescriptionSuggestion = ({ job, flow, resumeData, onAdd, selector, education }) => {
  const [loading, setLoading] = useState(false);
  const [suggestion, setSuggestion] = useState(null);
  const [closed, setClosed] = useState(false)
  const [error, setError] = useState(null);
  const wrapperRef = useRef(null);
  const [toolbarRect, setToolbarRect] = useState(null);
  useEffect(() => {
    if (resumeData?.aiSuggestion?.[selector || flow]) {
      setSuggestion(resumeData.aiSuggestion[selector || flow]);
    }
  }, [resumeData])
  useEffect(() => {
    // Find the Quill toolbar inside the wrapper
    if (wrapperRef.current) {
      const toolbar = wrapperRef.current.querySelector('.ql-toolbar');
      if (toolbar) {
        setToolbarRect(toolbar.getBoundingClientRect());
      }
    }
  }, [wrapperRef, loading, suggestion]);

  const handleGenerate = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await postRequest("guest-application/generate-description", { job,education, flow, selector, resume: resumeData });
      setSuggestion(response.data);
    } catch (e) {
      setError('Failed to generate suggestion.');
    }
    setLoading(false);
    
  };
  const onAddClick = () => {
    onAdd && onAdd(suggestion.description);
    setClosed(true)
    
  }
  if (closed) return null;
  
  // Helper function to decode HTML entities
  const decodeHtmlEntities = (html) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      return textarea.value;
  };

  return (
    <div ref={wrapperRef} className="description-suggestion">
      <Button onClick={handleGenerate} loading={loading} className="generate-ai-btn">
        {loading ? null : <FaMagic />} Write with AI
      </Button>
      <div className="suggestion-status">
        {loading && <div className="loader">
          <MoonLoader className="moonloader" size={40} />
          <div>Building bridges to your future job with AI...</div>
        </div>}
        {!loading && !suggestion?.description && <div className="empty-state">
          <div className="empty-state-content">
            <FaMagic />
            <div>Click "Write with AI" to generate a description</div>
          </div>
        </div>}
        {!loading && suggestion?.description && (
            <div 
                className="suggestion-content" 
                dangerouslySetInnerHTML={{ 
                    __html: decodeHtmlEntities(suggestion.description) 
                }} 
            />
        )}
        {!loading && suggestion?.description && <div className="suggestion-footer-buttons">
          <div className="generated-text-type">
            {suggestion?.tone &&
              <>
                <FaCheck />
                {suggestion?.tone}
              </>}
          </div>
          {!loading && <div className="right">
            <button onClick={handleGenerate}>
              <FaTimes />
              Skip</button>
            <button onClick={onAddClick} disabled={!suggestion?.description}>
              <FaPlus />
              <div>Add</div>
            </button>
          </div>}
        </div>}
      </div>

    </div>
  );
};

export default DescriptionSuggestion; 